// this is used in the Burger Menu for changing the country
// it will be redirected to another website

import { t } from 'ttag';

function isSelected(str) {
  if (window && window.config && window.config.pageMarket === str) return true;
  return false;
}

function defaultIcon() {
  if (window && window.config && window.config.pageMarket) {
    return window.config.pageMarket;
  }
  return 'com';
}

const countries = [
  {
    title: t`Change country`,
    online: true,
    base_item_id: 'website_selector',
    breakpoint: false,
    default_icon: defaultIcon(),
    items: [
      {
        base_item_id: 'website_selector_da',
        icon: 'dk',
        title: 'Danmark',
        slug: 'https://www.unisport.dk/',
        online: true,
        breakpoint: true,
        items: [],
        sorting: '',
        is_selected: isSelected('dk'),
        extra_data: 'fullurl'
      },
      {
        base_item_id: 'website_selector_se',
        icon: 'se',
        title: 'Sverige',
        slug: 'https://www.unisportstore.se/',
        online: true,
        breakpoint: true,
        items: [],
        sorting: '',
        is_selected: isSelected('se'),
        extra_data: 'fullurl'
      },
      {
        base_item_id: 'website_selector_no',
        icon: 'no',
        title: 'Norge',
        slug: 'https://www.unisportstore.no/',
        online: true,
        breakpoint: true,
        items: [],
        sorting: '',
        is_selected: isSelected('no'),
        extra_data: 'fullurl'
      },
      {
        base_item_id: 'website_selector_fi',
        icon: 'fi',
        title: 'Suomi',
        slug: 'https://www.unisportstore.fi/',
        online: true,
        breakpoint: true,
        items: [],
        sorting: '',
        is_selected: isSelected('fi'),
        extra_data: 'fullurl'
      },
      {
        base_item_id: 'website_selector_nl',
        icon: 'nl',
        title: 'Nederland',
        slug: 'https://www.unisportstore.nl/',
        online: true,
        breakpoint: true,
        items: [],
        sorting: '',
        is_selected: isSelected('nl'),
        extra_data: 'fullurl'
      },
      {
        base_item_id: 'website_selector_de',
        icon: 'de',
        title: 'Deutschland',
        slug: 'https://www.unisportstore.de/',
        online: true,
        breakpoint: true,
        items: [],
        sorting: '',
        is_selected: isSelected('de'),
        extra_data: 'fullurl'
      },
      {
        base_item_id: 'website_selector_fr',
        icon: 'fr',
        title: 'France',
        slug: 'https://www.unisportstore.fr/',
        online: true,
        breakpoint: true,
        items: [],
        sorting: '',
        is_selected: isSelected('fr'),
        extra_data: 'fullurl'
      },
      {
        base_item_id: 'website_selector_at',
        icon: 'at',
        title: 'Österreich',
        slug: 'https://www.unisportstore.at/',
        online: true,
        breakpoint: true,
        items: [],
        sorting: '',
        is_selected: isSelected('at'),
        extra_data: 'fullurl'
      },
      // {
      //   base_item_id: 'website_selector_pl',
      //   icon: 'pl',
      //   title: 'Polska',
      //   slug: 'https://www.unisport.pl/',
      //   online: true,
      //   breakpoint: true,
      //   items: [],
      //   sorting: '',
      //   is_selected: isSelected('pl'),
      //   extra_data: 'fullurl',
      // },
      {
        base_item_id: 'website_selector_com',
        icon: 'com',
        title: 'International',
        slug: 'https://www.unisportstore.com/',
        online: true,
        breakpoint: true,
        items: [],
        sorting: '',
        is_selected: isSelected('com'),
        extra_data: 'fullurl'
      }
    ]
  }
];

export default countries;
